import { render, staticRenderFns } from "./DependentCloner.vue?vue&type=template&id=07078ff8&"
import script from "./DependentCloner.vue?vue&type=script&lang=js&"
export * from "./DependentCloner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports